export const UPDATE_ALERT_CONFIG = `
  mutation UpdateAlertConfig($id: uuid!, $set: alert_configs_set_input!) {
    update_alert_configs_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      is_enabled
      send_email
      frequency
      updated_at
    }
  }
`;

export const UPDATE_ALERT_TYPE_SEVERITY = `
  mutation UpdateAlertTypeSeverity($code: String!, $severity: String!) {
    update_alert_type_configs_by_pk(
      pk_columns: { code: $code }
      _set: { severity: $severity }
    ) {
      code
      severity
    }
  }
`;

export const ADD_ALERT_CONFIG_TARGET = `
  mutation AddAlertConfigTarget($object: alert_config_targets_insert_input!) {
    insert_alert_config_targets_one(
      object: $object
      on_conflict: {
        constraint: alert_config_targets_config_id_target_type_target_value_key
        update_columns: []
      }
    ) { id target_type target_value }
  }
`;

export const DELETE_ALERT_CONFIG_TARGET = `
  mutation DeleteAlertConfigTarget($id: uuid!) {
    delete_alert_config_targets_by_pk(id: $id) { id }
  }
`;

export const DISMISS_ALERT = `
  mutation DismissAlert($object: alert_dismissals_insert_input!) {
    insert_alert_dismissals_one(
      object: $object
      on_conflict: {
        constraint: alert_dismissals_alert_instance_id_user_id_key
        update_columns: []
      }
    ) { id alert_instance_id user_id dismissed_at }
  }
`;

export const UNDISMISS_ALERT = `
  mutation UndismissAlert($alertInstanceId: uuid!, $userId: Int!) {
    delete_alert_dismissals(
      where: {
        alert_instance_id: { _eq: $alertInstanceId }
        user_id: { _eq: $userId }
      }
    ) { affected_rows }
  }
`;
